__turbopack_context__.v({
  "closeIcon": "Notification-module__IDGJ8G__closeIcon",
  "header": "Notification-module__IDGJ8G__header",
  "notification": "Notification-module__IDGJ8G__notification",
  "notificationContainer": "Notification-module__IDGJ8G__notificationContainer",
  "progress": "Notification-module__IDGJ8G__progress",
  "progressBar": "Notification-module__IDGJ8G__progressBar",
  "progressWrapper": "Notification-module__IDGJ8G__progressWrapper",
});
